import { CopyProperties } from '../decorator/copy-properties.decorator';
import { ProductInfo } from './product.info.model';

@CopyProperties()
export class Product {
  id: number;
  code: String;
  name: String;
  price: number;
  priceMoney: any;
  approveAt: any;
  releaseAt: any;
  expireAt: any;
  closeAt: any;
  buyMin: any;
  buyMax: any;
  sellMin: any;
  inStock: any;
  releaseVolume: any;
  website: any;
  firebaseKey: any;
  createAt: any;
  updateAt: any;
  productInfo: ProductInfo;
  currencyCode: any;
  statusCode: any;
  typeCode: any;
  countryCode: any;
  productFeeList: any[];
  productFeeDiscountList: any[];
  extra: any;
  featured: any;
  bankAccount: any;
  bondTerm: any;
  productAssetAllocationList: any[];
  productAssetAllocationModelList: any[];
  feeBuys: any[];
  feeSells: any[];
  timeHolds: any[];
  normalTimeHolds: any[];
  fees: any;
  type: any;
  isSubprime: boolean;
  isFixedYield: boolean;
  isProofOfRight: boolean;
  isTransferred: boolean;
  agents: any;
  isFixedInterestByAmount: any;
  assets: any;
  assetNames: any;
  endIssueAt: any;
  isDraft: any;
  status: any;
  closedBankNote: any;
  closedOrderBookAt: any;
  expectedReturn: any;
  managementFee: any;
  nav: number;
  holdingMin: number;
  lastYearNav: number;
  completeTransactionDuration: any;
  productSupervisoryBankAccount: any;
  fundType: any;
  fundTypeId: any;
  moneyTransferSyntax: any;
  moneyTransferSyntaxId: any;
  transactionDate: any;
  productTransactionDateList: any;
  assetAllocation1Id: any;
  assetAllocation2Id: any;
  riskLevelId: any;
  riskLevel: any;
  firstEndIssueAt: any;
  maturityAt: any;
  issuePrice: any;
  productSupervisoryBankAccountList: any;
  comment: any;
  issueValue: any;
  buyMinValue: any;
  buyMaxValue: any;
  performanceFee: number;
  transactionDates: any;
  firstIssueDate: any;
  endIssueDate: any;
  maturityDate: any;
  owner : any;
  issuerTypeId : any;
  national : any;
  bank: any;
  productBond: any;
  tradeCode: String;
  sipCode: string;
  closedOrderBookShiftDay: number;
  description: string;
  selectedDay: any;
  listFee: any;
  productAssetAllocationModel1: any;
  productAssetAllocationModel2: any;
  tradingTimeString: string;
  closedOrderBookString: string;
  closedBankNoteString: string;
  constructor(
    params?: any
  ) {
    this.id = 0;
    this.code = '';
    this.name = '';
    this.price = 0;
    this.approveAt = null;
    this.releaseAt = null;
    this.expireAt = 0;
    this.closeAt = 0;
    this.buyMin = 0;
    this.buyMax = 0;
    this.sellMin = 0;
    this.inStock = 0;
    this.releaseVolume = 0;
    this.website = null;
    this.firebaseKey = null;
    this.createAt = 0;
    this.updateAt = 0;
    this.productInfo = new ProductInfo();
    this.currencyCode = null;
    this.statusCode = null;
    this.typeCode = null;
    this.countryCode = null;
    this.productFeeList = [];
    this.productFeeDiscountList = [];
    this.extra = {};
    this.featured = false;
    this.bankAccount = {};
    this.tradeCode = '';
    this.sipCode = '';
    this.feeBuys  =  [];
    this.feeSells  =  [];
    this.feeBuys = [];
    this.fees  =  [];
    this.type  =  null;
    this.isSubprime  =  false;
    this.isFixedYield  =  false;
    this.isProofOfRight  =  false;
    this.isTransferred  =  false;
    this.agents  =  [];
    this.isFixedInterestByAmount  =  false;
    this.endIssueAt  =  new Date();
    this.isDraft  =  false;
    this.status  =  '';
    this.closedBankNote  =  '';
    this.closedOrderBookAt  = '';
    this.expectedReturn  =  0;
    this.managementFee  =  0;
    this.nav  =  0;
    this.holdingMin  =  0;
    this.lastYearNav  =  0;
    this.completeTransactionDuration  =  '';
    this.productSupervisoryBankAccount  =  {};
    this.fundType  =  '';
    this.fundTypeId  =  '';
    this.moneyTransferSyntax  =  {};
    this.moneyTransferSyntaxId  =  0;
    this.transactionDate  =  {};
    this.productTransactionDateList  =  [];
    this.assetAllocation1Id  =  null;
    this.assetAllocation2Id  =  null;
    this.riskLevelId  =  0;
    this.riskLevel  =  {};
    this.firstEndIssueAt  =  new Date();
    this.maturityAt  =  new Date();
    this.issuePrice  =  0;
    this.productSupervisoryBankAccountList  =  [];
    this.comment  =  '';
    this.issueValue  =  0;
    this.buyMinValue  =  0;
    this.buyMaxValue  =  0;
    this.performanceFee  =  0;
    this.transactionDates  =  [];
    this.firstIssueDate  =  new Date();
    this.endIssueDate  =  new Date();
    this.maturityDate  =  new Date();
    this.owner = null;;
    this.issuerTypeId = null;;
    this.national = null;;
    this.closedOrderBookShiftDay = 0;
    this.description = '';
    this.selectedDay = null;
    this.listFee = [];
    this.productAssetAllocationModel1 = null;
    this.productAssetAllocationModel2 = null;
    this.tradingTimeString = '';
    this.closedOrderBookString = '';
    this.closedBankNoteString = '';
    this.bank = null;
    this.productBond = null;
    this.productAssetAllocationList = [];
    this.productAssetAllocationModelList = [];
    this.timeHolds = [];
    this.normalTimeHolds = [];
    this.priceMoney = '';
    this.bondTerm = null;
    this.assets = '';
    this.assetNames = '';
  }
}
